/**
 * Whether the viewer asked for reduced motion (`prefers-reduced-motion: reduce`). For motion driven
 * from script (a Pixi ticker, a mount-time animation) that CSS media queries cannot reach. Read at
 * call time, so a caller that animates per frame should read it once per animation, not cache it.
 */
export function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}
